// extracted by mini-css-extract-plugin
export default {"root":"gjmLZ_","bg":"MbaI8m","arrow":"jOxHi4"};